import { useSelector } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { Link } from 'react-router-dom';
import { Container } from '@plone/components';
import type { Content } from '@plone/types';
import config from '@plone/registry';

const Tags = ({ content }: { content: Content }) => {
  const tags = content?.subjects || [];
  const navroot = useSelector(
    (state: any) => state.navroot?.data?.navroot?.['@id'] || '/',
  );
  if (!config.settings.showTags || !tags.length) return null;

  return (
    <Container narrow className="tags">
      <div className="tag-wrapper">
        <span className="title">Tags :</span>
        {tags.map((tag, index) => (
          <span key={tag}>
            <Link
              className="ui label"
              to={`${flattenToAppURL(navroot)}/search?Subject=${tag}`}
            >
              {tag}
            </Link>
            {index < tags.length - 1 && <span className="separator">, </span>}
            {index === tags.length - 1 && <span className="period">.</span>}
          </span>
        ))}
      </div>
    </Container>
  );
};

export default Tags;
